// extracted by mini-css-extract-plugin
export default {"root":"CloseIconButton_root__0V4KW"};